<script>
import Vue from 'vue'

export default {
  data() {
    return {
      last_scroll_top: 0,
      paused: false,
      log_messages: []
    }
  },
  computed: {
    get_log_messages() {
      if(this.paused) {
        return this.log_messages
      }
      return this.$store.state.log_messages
    }
  },
  methods: {
    clear_log() {
      this.$store.dispatch('clear_log')
      this.log_messages = []
    },
    pause() {
      this.paused = !this.paused
      if(this.paused) {
        this.log_messages = this.$store.state.log_messages
      }
    },
    update_scroll() {
      Vue.nextTick(() => {
        this.$refs.console.scrollTop = this.$refs.console.scrollHeight
        this.last_scroll_top = this.$refs.console.scrollTop
      })
    }
  },
  mounted() {
    this.update_scroll()
  },
  name: 'candela-console',
  watch: {
    get_log_messages() {
      // delay setting scroll position while the latest message is rendered
      const curr_scroll_top = this.$refs.console.scrollTop
      if(curr_scroll_top >= this.last_scroll_top) {
        this.update_scroll()
      }
    }
  }
}
</script>

<template lang='html'>
<div class='pos-rel flex-grow-1'>
  <div class='candela-console d-flex flex-column'>
    <div ref='console' class='console-container d-flex flex-column'>
      <div class='msg-container'>
        <div class='message px-4 py-2' v-for='(log, i) in get_log_messages' :key='i'>
          <div :class='[`console-mono`, `${log.level}--text`, `py-2`]'>
            {{log.message}}
          </div>
        </div>
      </div>
    </div>
    <div class='bottom-bar d-flex justify-end px-4 py-2'>
      <v-btn @click='pause' color='primary'
        class='mr-2' outlined small>
        <v-icon x-small color='primary'>
          {{paused ? `fa-play` : `fa-pause`}}
        </v-icon>
      </v-btn>
      <v-btn @click='clear_log' color='error' outlined small>
        <v-icon x-small>fa-ban</v-icon>
      </v-btn>
    </div>
  </div>
</div>
</template>

<style lang='sass' scoped>
.candela-console
  min-height: 100%
  max-height: 100%
  position: absolute
  width: 100%

.console-container
  flex-grow: 1
  overflow: auto

  .msg-container
    .message
      .console-mono
        font-family: IBMPlex Mono, monospace
        white-space: wrap

.theme--dark
  .bottom-bar
    background-color: var(--v-grey-darken9)
    border-top: 1px solid var(--v-grey-darken8)

  .message
    border-bottom: 1px solid var(--v-grey-darken8)

.theme--light
  .bottom-bar
    background-color: white
    border-top: 1px solid var(--v-grey-lighten6)

  .message
    border-bottom: 1px solid var(--v-grey-lighten6)
</style>
